import builder from './reducerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_LIST_ERROR,
} from '../constants'

export default builder(
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADING,
  ACTION_ENTERPRISE_ACCOUNT_LIST_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_LIST_ERROR)



// WEBPACK FOOTER //
// ./src/store/enterpriseAccountsReducer.js